import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import Typography from '../typography';

export const HyperlinkSC = styled(Typography)`
  ${({ theme }) => css`
    color: ${theme.color.tint.highlight} !important;
    transition-property: color, opacity;
    transition-duration: 0.2s;
    text-decoration: none;

    &:visited {
      color: ${theme.color.tint.tertiary};
      text-decoration: none;
    }

    &:active {
      color: ${theme.color.tint.highlight};
      text-decoration: none;
    }

    &:hover {
      color: ${theme.color.state.active};
      text-decoration: none;
    }

    &:disabled {
      opacity: 0.5;
      color: ${theme.color.tint.highlight};
      text-decoration: none;
    }
  `};
` as typeof Typography;

export const RouterHyperlinkSC = styled(Link)`
  ${({ theme }) => css`
    transition-property: color, opacity;
    transition-duration: 0.2s;
    text-decoration: none;
    color: ${theme.color.tint.action};

    &:visited {
      color: ${theme.color.tint.action};
      text-decoration: none;
    }

    &:active {
      color: ${theme.color.tint.highlight};
      text-decoration: none;
    }

    &:hover {
      color: ${theme.color.tint.highlight};
      text-decoration: none;
    }

    &:disabled {
      opacity: 0.5;
      color: ${theme.color.tint.action};
      text-decoration: none;
    }
  `};
`;
